// ================================
// Constantes de configuração REST API
// ================================

export const cAUTENTICACAO_ERP = {
  TOKEN_CONSUMIDOR: 'REC-466B5037-537C-4996-8E72-E9AC4285',
  SISTEMA: 36,
};

export const cBASE_URL_API_TEKMONITOR = 'https://api.monitor.teksystem.com.br';
export const cBASE_URL_API = `${window.location.protocol}//${window.location.hostname}:8080`;

export const cENDPOINT_LOGIN_TEKSERVER = '/auth';
export const cENDPOINT_LOGIN_API = '/v1/security/login';
// ================================
//  Constantes de Gerais
// ===============================

export const cCLIENTE_DEMONSTRACAO = {
  CODIGO: 5,
  VERSAO: '2.00',
  DESCRICAO: 'DEMONSTRAÇÃO',
};

export const cINTERVALO_ATUALIZACAO_AOVIVO = 5 * 1000; // 15s
export const cCODIGO_CLIENTE_TEKSYSTEM = 1000;
export const cCODIGO_CLIENTE_TEKDASHBOARD = -1000;
export const cCLIENTES_LOGIN_LOCAL = [151, 193, 215, 216, 502, 516, 518, 609, 1000];

export const cURL_APLICACAO_PLAY_STORE =
  'https://play.google.com/store/apps/details?id=br.com.teksystem.tekdashboard.twa';

export const cURL_APLICACAO_APP_STORE = 'https://apps.apple.com/app/6749776923';

export const cVERSOES_ERP = {
  v161_01: {
    codigo: '3788',
    numero: '161.01',
  },

  v162_08: {
    codigo: '3812',
    numero: '162.08',
  },

  v163_00: {
    codigo: '3793',
    numero: '163.00',
  },

  v166_04: {
    codigo: '3873',
    numero: '166.04',
  },
};

// ================================
// Constantes de design/estilização
// ================================

export const cCORES: { vuetify: string; hexadecimal: string; descricao: string }[] = [
  { vuetify: 'primary', hexadecimal: '#1976D2', descricao: 'Azul' },
  { vuetify: 'success', hexadecimal: '#4CAF50', descricao: 'Verde' },
  { vuetify: 'warning', hexadecimal: '#FB8C00', descricao: 'Laranja' },
  { vuetify: 'error', hexadecimal: '#FF5252', descricao: 'Vermelho' },
  { vuetify: 'purple', hexadecimal: '#9C27B0', descricao: 'Roxo' },
  { vuetify: 'cyan', hexadecimal: '#00BCD4', descricao: 'Ciano' },
  { vuetify: 'pink', hexadecimal: '#E91E63', descricao: 'Rosa' },
  { vuetify: 'blue-grey', hexadecimal: '#607D8B', descricao: 'Azul Cinza' },
];

export const cCOR_AZUL_TEKSYSTEM = 'rgba(0, 12, 80, 0.85)';
export const cCOR_VERMELHO_TEKSYSTEM = 'rgba(177, 18, 18, 0.85)';
export const cLABEL_AGRUPAMENTO_DADOS_GRAFICO = 'OUTROS';
export const cCORES_LABELS_GRAFICO = [
  '#4169E1', // Azul Royal
  '#E67E22', // Laranja Queimado
  '#2ECC71', // Verde Esmeralda
  '#DC143C', // Vermelho Carmesim
  '#9B59B6', // Roxo Ametista
  '#F1C40F', // Amarelo Ouro
  '#1ABC9C', // Turquesa
  '#FA8072', // Rosa Salmão
  //'#000080', // Azul Marinho
  '#808000', // Verde Oliva
  '#2c588d',
  '#87CEEB', // Azul Céu
  '#8B4513', // Marrom Sela
  '#32CD32', // Verde Limão
  '#708090', // Cinza Ardósia
  '#FF7F50', // Coral
  '#4B0082', // Índigo
  '#3EB489', // Verde Menta
  '#800000', // Bordô
  '#D2B48C', // Areia
  '#36454F', // Carvão

  /*
  '#2c588d',
  '#E53935',
  '#43A047',
  '#C0CA33',
  */

  /*
  '#2c588d',
  '#6b94be',
  '#899bb2',
  '#adb6bc',
  '#747488',
  '#777f8c',
  '#648474',
  '#8cbcac',
  '#3b5b6b',
  '#4c6c9c',
  '#5c7d9c',
  '#6c8e9c',
  '#82b2b7',
  '#71a0ba',
  '#94c3b4',
  */

  // '#9fb9d4',
  // '#b9cbdf',
  // '#d3deea',
  // '#edf0f5'
];
